import {Helmet} from '@dr.pogodin/react-helmet';
import {Action, showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {isString} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds, workshopRoutes} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, Main, usePermissions} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import {ActionCallback} from 'features/eag-grid';

export function WorkshopInterest() {
  const navigate = useNavigate();

  const [canCreateWorkshopInterest] = usePermissions({
    permissionKeys: ['workshopInterestCreate'],
    scopes: {
      workshopInterestCreate: {
        // no need for scopes, general creation without specified participation
        participation: 'SKIP',
        // no need for scopes, general creation without specified branch
        branchId: 'SKIP',
      },
    },
  });

  const actions: Action[] = [
    {
      type: 'button',
      onClick: () => navigate(workshopRoutes.interestCreate),
      variant: 'primary',
      isDisabled: !canCreateWorkshopInterest,
      tooltip: !canCreateWorkshopInterest ? i18n.t('general.labels.noPermission') : undefined,
      'data-testid': testIds.workshop.interest('create'),
      title: i18n.t('entity.interest.actions.newInterest'),
    },
  ];

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    if (!isString(rowId)) {
      showNotification.error();
      return;
    }

    match(actionKey)
      .with('redirectDetail', 'detail', () =>
        navigate(
          composePath(workshopRoutes.interestDetailOverview, {
            params: {id: rowId},
            isSearchParamsPreserved: false,
            queryParams: sourceSearchParams,
          })
        )
      )
      .with('detail_newTab', () => {
        window.open(
          composePath(workshopRoutes.interestDetailOverview, {
            params: {id: rowId},
            isSearchParamsPreserved: false,
            queryParams: sourceSearchParams,
          })
        );
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <>
      <Helmet title={i18n.t('page.workshop.labels.workshopInterest')} />
      <Main data-testid={testIds.workshop.interest('page')} isFullHeight actions={actions}>
        <DmsDataGrid
          gridCode="workshop-interest"
          actionCallback={actionCallback}
          data-testid={testIds.workshop.interest('datagrid')}
        />
      </Main>
    </>
  );
}
